import React from "react";

export const vrmRef = React.createRef();